<template>
    <div class="form-group">
        <label class="label">
            {{ label }}
            {{ required ? '*' : '' }}
        </label>

        <date-picker  
            @input="handleInput"
            :name="name"
            :type="type"
            :required="required"
            :disabled="disabled"
            :placeholder="placeholder"
            :value="value"
            :format="format"
            class=""
            v-bind:class="{ 'is-invalid': error }"
            :disabled-date="disabledDate"
            :disabled-time="disabledTime"
            :default-value="new Date(new Date().setHours(23, 59, 0, 0))"
            :minute-options="minuteOptions"
            :hour-options="hourOptions"
        />

        <small
            v-if="helperText"
            class="form-text"
            v-bind:class="{ 'invalid-feedback': error, 'text-muted': !error }"
        >
            {{ helperText }}
        </small>
    </div>
</template>

<script>

import DatePicker from 'vue2-datepicker';
import 'vue2-datepicker/index.css';

export default {
    components: { DatePicker },
    props: {
        id: {
            type: String,
            required: false,
        },
        label: {
            type: String,
            required: false,
        },
        value: {
            required: true,
        },
        name: {
            type: String,
            required: false,
        },
        error: {
            type: Boolean,
            required: false,
            default: false
        },
        disabled: {
            type: Boolean,
            required: false,
            default: false
        },
        helperText: {
            type: String,
            required: false,
            default: null
        },
        required: {
            type: Boolean,
            required: false,
            default: false
        },
        type: {
            required: false,
        },
        format: {
            required: false,
        },
        placeholder: {
            type: String,
            required: false,
        },
        disabledDate: {
            type: Function,
            required: false,
            default: (date, currentValue) => false
        },
        disabledTime: {
            type: Function,
            required: false,
            default: (date) => false
        },
    },
    data(){
        return {
            content: this.value,
        };
    },
    computed: {
        minuteOptions () {
            return Array.from({length: 60}, (x, i) => i).reverse();
        },
        hourOptions () {
            return Array.from({length: 24}, (x, i) => i).reverse();
        },
    },
    methods: {
        handleInput (value) {
            this.$emit('input', value)
            this.$emit('change', value)

        },
    },
    mounted() {
    }
}
</script>

<style lang="scss">
.mx-datepicker{
    width: 100%;

    &.is-invalid {
        .mx-input-wrapper{
            .mx-input {
                border-color: #dc3545;
            }
        }
    }

    .mx-input-wrapper{
        width: 100%;


        .mx-input {
            display: block;
            width: 100%;
            height: calc(1.5em + 0.75rem + 2px);
            padding: 0.375rem 0.75rem;
            font-size: 1rem;
            font-weight: 400;
            line-height: 1.5;
            color: #495057;
            background-color: #fff;
            background-clip: padding-box;
            border: 1px solid #ced4da;
            border-radius: 0.25rem;
            transition: border-color 0.15s ease-in-out, box-shadow 0.15s ease-in-out;
        }
    }
}
</style>
